var _a;
import { defineComponent, ref, computed, watch, onMounted, createBlock, openBlock, withCtx, createElementVNode, createElementBlock, Fragment, createCommentVNode, createVNode, createTextVNode, toDisplayString, defineAsyncComponent, onBeforeMount, normalizeClass, mergeProps, withDirectives, vShow, mergeModels, useModel } from "vue";
import { registerEntityEndpoint, getI18n, ROUTES, quasarValidateRules, PLACEHOLDER_UUID, BCheckbox, resetDateTimeUnits } from "@editor/ui-utils";
import { QAvatar, QTooltip, useFormChild, QInput, QImg, QIcon, QDialog, QCardSection, QCard, QBtn, QBadge } from "quasar";
import { useI18n } from "vue-i18n";
import { StatusIcon } from "@editor/ui-layout";
import { defineStore } from "pinia";
const de = {
  images: {
    contentBlockLabel: "Bild",
    components: {
      imagesOversizeOne: "Bild ist zu groß. Die maximale Uploadgröße ist {maxFileSize}MB",
      imagesOversizeMulti: "Bilder ist zu groß. Die maximale Uploadgröße ist {maxFileSize}MB",
      imageSelectorHintInvalid: "ungültiges Bild",
      imageSelectorHintUnknown: "unbekannter Fehler",
      uploadImage: "Bild hochladen",
      editImage: "Bild bearbeiten",
      imageSelect: "Auswählen",
      imageSelected: "Ausgewählt",
      imageExpiresIn: "Läuft in {n} Tagen ab",
      imagePublish: "Online in {n} Tagen",
      imageExpired: "Abgelaufen",
      imageExpires: "Läuft ab",
      imageCreated: "Erstellt",
      imageTitle: "Titel",
      imageCredits: "Quelle",
      imageStatus: "Status",
      aspectText: "Vorschau für verschiedene Bildgrößen basierend auf dem Fokuspunkt",
      aspectTeaser: "Teaserbild auf Mobile",
      aspectTitle: "Teaserbild Artikel/Home/Channel auf Mobile, Desktop, Tablet",
      aspectDesktop: "Teaserbild Home/Channel auf Desktop",
      aspectDesc: "Wenn der Fokuspunkt gesetzt wird, ist die Vorschau nach dem Speichern hier sichtbar.",
      aspectClick: "Bitte auf das quadratische Bild fokusieren",
      imageDeleted: "Gelöscht",
      imageDraft: "Entwurf",
      selectorNotPublishedWarning: "WARNUNG: Dieses Bild wird im veröffentlichten Artikel nicht sichtbar sein"
    },
    backButton: "Zurück zur Bilderliste",
    title: "Bildname",
    altText: "Alt-Text",
    altTextHint: "Wenn nicht befüllt, wird der Bildname genutzt",
    captionTextHint: "Wenn nicht befüllt, wird der Bildname genutzt",
    caption: "Bildunterschrift",
    selectImage: "Bild hochladen. Limit: {maxFileSize}MB oder 30 Mio. Pixel (Breite mal Höhe)",
    addImage: "Bild hinzufügen",
    removeImage: "Bild entfernen",
    source: "Quelle",
    license: "Lizenz",
    publishedAt: "Veröffentlichungsdatum",
    expiredAt: "Ablaufdatum",
    msn: "MSN Service",
    deleteImage: "Bild löschen",
    messageConfirmDelete: "Bist du dir sicher, dass du Bild löschen möchtest?",
    messageMaxFileSize: "Maximale Dateigröße ist {maxFileSize}MB",
    messageMandatoryInformation: "Du kannst das Bild nicht speichern, da benötigte Informationen fehlen",
    messageUpload: "Bild hochgeladen",
    messageSaved: "Bild gespeichert",
    messageTooBig: "Bild ist zu groß. Maximale Dateigröße ist {maxFileSize}MB",
    messageDeleted: "Bild gelöscht",
    messagePublishTitle: "Bild veröffentlichen",
    messagePublish: "Bist du sicher, dass du den Bild veröffentlichen möchtest?",
    messageDeleteImageTitle: "Bild löschen",
    messageDeleteImage: "Sind Sie sicher, dass Sie dieses Bild löschen möchten?",
    messageConfirmUnpublishImage: "Sind Sie sicher, dass Sie das Bild offline nehmen möchten?",
    messageUnpublishTitle: "Bild offline nehmen",
    messageConfirmDraftImage: "Sind Sie sicher, dass Sie das Bild als Entwurf festlegen möchten?",
    messageRepublishInFuture: "Sind Sie sicher, dass Sie das Bild offline nehmen und für die zukünftige Veröffentlichung planen möchten?",
    messageRepublishInFutureTitle: "Veröffentlichung verschieben",
    messageTooSmall: "Die Bildauflösung liegt unter der Mindestanforderung von 1200x675 Pixel. Bitte laden Sie ein größeres Bild hoch.",
    messageTooHighResolution: "Bilder über 30 Millionen Pixel können nicht einmal für den Bild-Upload ausgewählt werden.",
    saveDraft: "Entwurf speichern",
    saveOffline: "Bild offline nehmen",
    savePublish: "Veröffentlichen",
    saveScheduled: "Veröffentlichung planen",
    invalid: "Ungültig",
    setFocalPoint: "Bitte setze den Fokuspunkt, indem du auf das Bild klickst.*",
    articleLabel: "Artikel",
    invalidVideoCover: "Abgelaufen",
    invalidVideoCoverTooltip: "Die Bildvorschau für dieses Video ist abgelaufen.",
    deletedVideoCover: "Gelöscht",
    deletedVideoCoverTooltip: "Die Bildvorschau für dieses Video ist gelöscht.",
    notAnImageFile: "Die ausgewählte Datei ist kein Bild",
    modeUnpublished: "Offline genommen",
    modeScheduled: "Veröffentlichung geplant",
    modePublished: "Veröffentlicht",
    modeDraft: "Entwurf",
    noEditTooltip: "Dieses Bild stammt ursprünglich aus dem {source}-Editor",
    handledInLegacySystem: "Dieses Bild wird in {source} bearbeitet, Sie können es nicht auf Vibe bearbeiten"
  },
  imagesList: {
    addSelected: "Ausgewählte Bilder hinzufügen",
    title: "Bilder",
    newButton: "Neues Bild",
    multi: "Ausgewählte Bilder hinzufügen",
    search: "Nach Bildname, Bildunterschrift oder Alt-Text suchen",
    status: "Bildstatus",
    dpAll: "Alle",
    dpSchedule: "Geplant",
    dpPublished: "Veröffentlicht",
    dpExpired: "Depubliziert",
    date: "Erstellungsdatum",
    credits: "Bildquelle",
    uuid: "Bild-UUID",
    noImages: "Entschuldigung, wir haben keine Bilder gefunden, die den ausgewählten Kriterien entsprechen",
    xymatic: "Videobilder anzeigen",
    showPartnerImages: "Partnerbilder anzeigen",
    partnerImageBadge: "Partner Bild"
  }
};
const en = {
  images: {
    contentBlockLabel: "Image",
    components: {
      imagesOversizeOne: "Image is too big. Maximum upload size is {maxFileSize}MB",
      imagesOversizeMulti: "Images are too big. Maximum upload size is {maxFileSize}MB",
      imageSelectorHintInvalid: "Invalid image",
      imageSelectorHintUnknown: "Unknown error",
      uploadImage: "Upload Image",
      editImage: "Edit Image",
      imageSelect: "Select image",
      imageSelected: "Selected",
      imageExpiresIn: "Expires in {n} days",
      imageExpired: "Expired",
      imageExpires: "Expires",
      imagePublish: "Online in {n} days",
      imageCreated: "Created",
      imageTitle: "Title",
      imageCredits: "Credits",
      imageStatus: "Status",
      aspectText: "Preview for different image sizes based on the focal point",
      aspectTeaser: "Teaser image on mobile",
      aspectTitle: "Teaser image article/home/channel on mobile, desktop, tablet",
      aspectDesktop: "Teaser image home/channel on desktop",
      aspectDesc: "After setting the focal point, the preview is visible here after saving.",
      aspectClick: "Please focus on the square image",
      imageDeleted: "Deleted",
      imageDraft: "Draft",
      selectorNotPublishedWarning: "WARNING: This image will not be visible in the published article"
    },
    backButton: "Back to images list",
    title: "Title",
    altText: "Alt Text",
    altTextHint: "If not filled, the title is used",
    captionTextHint: "If not filled, the title is used",
    caption: "Caption",
    selectImage: "Select or upload image. {maxFileSize}MB Limit. 30.000.000 pixels limit (combined height * width).",
    addImage: "Add image",
    removeImage: "Remove image",
    source: "Source",
    license: "License",
    publishedAt: "Published at",
    expiredAt: "Expired at",
    msn: "MSN Service",
    deleteImage: "Delete image",
    messageConfirmDelete: "Are you sure you want to delete image?",
    messageMaxFileSize: "Maximum file size is {maxFileSize}MB",
    // eslint-disable-next-line @typescript-eslint/quotes
    messageMandatoryInformation: "You can't save this image because it is missing mandatory information",
    messageUpload: "Image uploaded",
    messageSaved: "Image saved",
    messageTooBig: "Image too large. Maximum file size is {maxFileSize}MB",
    messageDeleted: "Image deleted",
    messagePublishTitle: "Publish image",
    messagePublish: "Are you sure you want to publish this image?",
    messageDeleteImageTitle: "Delete image",
    messageDeleteImage: "Are you sure you want to delete this image?",
    messageConfirmUnpublishImage: "Are you sure you want to take image offline?",
    messageUnpublishTitle: "Take image offline",
    messageConfirmDraftImage: "Are you sure you want to set image as draft?",
    messageRepublishInFuture: "Are you sure you want to take image offline and schedule it to be published in the future?",
    messageRepublishInFutureTitle: "Reschedule publishing",
    messageTooSmall: "Image resolution is below minimal requirement of 1200x675 pixel. Please consider uploading bigger image.",
    messageTooHighResolution: "Image above 30 milion pixels is not even selectable for image upload.",
    saveDraft: "Save draft",
    saveOffline: "Take offline",
    savePublish: "Publish",
    saveScheduled: "Schedule publication",
    invalid: "Invalid",
    setFocalPoint: "Please set the focal point by clicking on the image.*",
    articleLabel: "Article",
    invalidVideoCover: "Expired",
    invalidVideoCoverTooltip: "This video has an expired image preview.",
    deletedVideoCover: "Deleted",
    deletedVideoCoverTooltip: "The image preview for this video has been deleted.",
    notAnImageFile: "Selected file is not an image",
    modeUnpublished: "Image offline",
    modeScheduled: "Publishing date scheduled",
    modePublished: "Published",
    modeDraft: "Draft",
    noEditTooltip: "This image is originally from the {source} editor",
    handledInLegacySystem: "This image is being handled in {source}, you can't edit it on Vibe"
  },
  imagesList: {
    addSelected: "Add selected images",
    title: "Images",
    newButton: "New image",
    multi: "Add selected images",
    search: "Search by title, caption or alt text",
    status: "Status",
    dpAll: "All",
    dpSchedule: "Scheduled",
    dpPublished: "Published",
    dpExpired: "Expired",
    date: "Period",
    credits: "Credits",
    uuid: "Image UUID",
    noImages: "Sorry, we couldn't find any images mathing your search criteria",
    xymatic: "Show video images",
    showPartnerImages: "Show partner images",
    partnerImageBadge: "Partner image"
  }
};
const messages = { en, de };
const ImageModelName = "Images";
const ImageService = registerEntityEndpoint(ImageModelName);
const { getEntity, listEntities, postEntity, putEntity, deleteEntity, getEntityAPIClient } = ImageService;
const getImages = async (search = null) => {
  return listEntities({ params: { search: search || null } });
};
const commonExcludedFields = {
  _id: void 0,
  createDate: void 0,
  changeDate: void 0,
  isDeleted: void 0,
  source: void 0
};
const getImage = async (id, includePreview = false) => {
  return getEntity(id, { params: { includePreview } });
};
const getImageUrl = (uuid, width = 640, height = 360) => {
  return `${getEntityAPIClient().defaults.baseURL}/${uuid}/url/${width}/${height}`;
};
const createImage = async (data) => {
  const sanitizedData = { ...data, ...commonExcludedFields };
  return postEntity(sanitizedData);
};
const updateImage = async (id, data) => {
  const sanitizedData = { ...data, ...commonExcludedFields };
  return putEntity(id, sanitizedData);
};
const uploadImage = async (image, fileBlob) => {
  const sanitizedImage = { ...image, ...commonExcludedFields };
  const formData = new FormData();
  formData.append("image", JSON.stringify(sanitizedImage));
  formData.append("file", fileBlob);
  return postEntity(formData, {
    headers: {
      "content-type": "multipart/form-data"
    }
  });
};
const replaceImage = async (image, fileBlob) => {
  const sanitizedImage = { ...image, ...commonExcludedFields };
  const formData = new FormData();
  formData.append("image", JSON.stringify(sanitizedImage));
  formData.append("file", fileBlob);
  return putEntity(`${image._id}/replace`, formData, {
    headers: {
      "content-type": "multipart/form-data"
    }
  });
};
const editImage = async (image) => {
  const sanitizedImage = { ...image, ...commonExcludedFields };
  return putEntity(image._id || "", sanitizedImage);
};
const deleteImage = async (image) => {
  return deleteEntity(image._id);
};
const getDefaultImageBlock = () => ({
  type: "IMAGE",
  imageUuid: "",
  imageLinkOutUrl: "",
  hasNoFollow: false,
  hasAffiliate: false,
  hasNewTab: false
});
const routes = [
  {
    path: `/${ROUTES.images.path}`,
    meta: { i18RouteTitleKey: ROUTES.images.path },
    children: [
      {
        path: "",
        name: "image_list",
        component: () => import("./image-list-C-rMneAV.js"),
        meta: { requiredRight: "navigate_list_images" }
      },
      {
        path: "new",
        name: "image_new",
        component: () => import("./image-edit-BJMa_0Fb.js"),
        props: () => ({ title: getI18n().t("router.createImage"), backRoute: "/images" }),
        meta: { requiredRight: "navigate_image" }
      },
      {
        path: ":id",
        name: "image_detail",
        component: () => import("./image-edit-BJMa_0Fb.js"),
        props: (route) => ({ title: getI18n().t("router.editImage"), id: route.params.id, backRoute: "/images" }),
        meta: { requiredRight: "navigate_image" }
      }
    ]
  }
];
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "avatar-image",
  props: {
    imageUuid: { type: String, required: true },
    size: { type: String, required: false, default: "24px" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const src = ref(void 0);
    const size = computed(() => {
      const num = /^[0-9]+/.exec(props.size);
      return num ? parseInt(num[0]) : 24;
    });
    const loadImage = async () => {
      src.value = getImageUrl(props.imageUuid, size.value, size.value);
    };
    watch(size, loadImage);
    onMounted(loadImage);
    const __returned__ = { props, src, size, loadImage, get QAvatar() {
      return QAvatar;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$4 = ["src", "width", "height"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QAvatar"], {
    size: $setup.props.size
  }, {
    default: withCtx(() => [
      createElementVNode("img", {
        src: $setup.src,
        alt: "Avatar",
        width: $setup.size,
        height: $setup.size
      }, null, 8, _hoisted_1$4)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["size"]);
}
const avatarImage = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__file", "/builds/CT/content-technology-framework/modules/image/editor-ui/src/components/avatar-image.vue"]]);
function getImmutableConfig(mutableConfig) {
  return deepFreeze(mutableConfig);
}
function deepFreeze(object) {
  Object.getOwnPropertyNames(object).forEach((name) => {
    const value = object[name];
    if (value && (typeof value === "object" || typeof value === "function") && !Object.isFrozen(value)) {
      deepFreeze(value);
    }
  });
  return Object.freeze(object);
}
function extendEnv(envConfig, baseConfig) {
  const result = {};
  for (const key in { ...baseConfig, ...envConfig }) {
    if (typeof baseConfig[key] === "object" && !Array.isArray(baseConfig[key]) && baseConfig[key] !== null && envConfig && key in envConfig) {
      const deepEnvConfig = envConfig[key];
      const deepBaseConfig = baseConfig[key];
      result[key] = extendEnv(deepEnvConfig, deepBaseConfig);
    } else if (envConfig && key in envConfig && typeof envConfig[key] === "function") {
      result[key] = envConfig[key].bind(result);
    } else if (typeof baseConfig[key] === "function") {
      result[key] = baseConfig[key].bind(result);
    } else if (envConfig && key in envConfig) {
      result[key] = envConfig[key];
    } else {
      result[key] = baseConfig[key];
    }
  }
  return result;
}
function getEnvVariableDefault(variable, defaultValue) {
  if (typeof process !== "undefined") {
    const resolved = process.env[variable];
    if (resolved !== void 0) {
      return resolved;
    }
  }
  return defaultValue;
}
function getEnvVariable(variable) {
  if (typeof process !== "undefined") {
    const resolved = process.env[variable];
    if (resolved !== void 0) {
      return resolved;
    }
  }
  return void 0;
}
function getEnvironmentConfig(configDefinition) {
  const { base, ...availableConfigs } = configDefinition;
  let envConfig;
  if (typeof process === "undefined") {
    envConfig = availableConfigs.local;
    if (!envConfig) {
      throw new Error("Local env config is undefined!");
    }
  } else {
    if (process.env.NODE_ENV === void 0) {
      throw new Error("NODE_ENV is undefined.\nHint: configuration should be initialized lazily during runtime and not during build time.");
    }
    envConfig = availableConfigs[process.env.NODE_ENV];
    if (envConfig === void 0) {
      throw new Error(`NODE_ENV=${process.env.NODE_ENV}. Allowed values=${Object.keys(availableConfigs).join(", ")}`);
    }
  }
  return getImmutableConfig(extendEnv(envConfig, base));
}
function getFeatureBranchPrefix() {
  if (typeof process === "undefined") {
    return "";
  }
  return process.env.BRANCH_SANDBOX_NAME ? `${process.env.BRANCH_SANDBOX_NAME}.` : "";
}
var Brands;
(function(Brands2) {
  Brands2["BUNTE"] = "bunte";
  Brands2["CHIP"] = "chip";
  Brands2["FOCUS"] = "focus";
  Brands2["FITFORFUN"] = "fitforfun";
})(Brands || (Brands = {}));
var LegacyBrands;
(function(LegacyBrands2) {
  LegacyBrands2["BUNTE"] = "bunte";
  LegacyBrands2["CHIP"] = "chip";
  LegacyBrands2["FOCUS"] = "focus";
  LegacyBrands2["PRAXISTIPPS"] = "praxistipps";
})(LegacyBrands || (LegacyBrands = {}));
var Environments;
(function(Environments2) {
  Environments2["LOCAL"] = "local";
  Environments2["LOCAL_E2E"] = "local_e2e";
  Environments2["SANDBOX"] = "sandbox";
  Environments2["DEVELOPMENT"] = "development";
  Environments2["STAGING"] = "staging";
  Environments2["PRODUCTION"] = "production";
  Environments2["TEST"] = "test";
})(Environments || (Environments = {}));
({
  "bunte-stack": Brands.BUNTE,
  interred: Brands.CHIP,
  escenic: Brands.FOCUS
});
({
  [Brands.BUNTE]: "bunte-stack",
  [Brands.CHIP]: "interred",
  [Brands.FOCUS]: "escenic"
});
var AspectRatio;
(function(AspectRatio2) {
  AspectRatio2[AspectRatio2["SQUARE"] = 1] = "SQUARE";
  AspectRatio2[AspectRatio2["WIDESCREEN"] = 1.7778] = "WIDESCREEN";
  AspectRatio2[AspectRatio2["ULTRAWIDESCREEN"] = 2.3333] = "ULTRAWIDESCREEN";
})(AspectRatio || (AspectRatio = {}));
({
  base: {
    cdn: {
      hashSecret: getEnvVariable("AKAMAI_HASH_SHARED_SECRET")
    },
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d",
        [Brands.BUNTE]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d"
      }
    }
  },
  local: {
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d",
        [Brands.BUNTE]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d"
      }
    }
  },
  local_e2e: {
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d",
        [Brands.BUNTE]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d"
      }
    }
  },
  development: {
    cdn: {
      hashSecret: getEnvVariable("AKAMAI_HASH_SHARED_SECRET")
    },
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "3232e577-e843-477d-b913-15428acd66a1",
        [Brands.BUNTE]: "8d2ac2ca-9045-4150-88c2-30f5969693c0"
      }
    }
  },
  sandbox: {
    cdn: {
      hashSecret: getEnvVariable("AKAMAI_HASH_SHARED_SECRET")
    },
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d",
        [Brands.BUNTE]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d"
      }
    }
  },
  test: {
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d",
        [Brands.BUNTE]: "fc5d3e8b-6f5e-43b4-b6e5-c5b5e4d58b2d"
      }
    }
  },
  staging: {
    cdn: {
      hashSecret: getEnvVariable("AKAMAI_HASH_SHARED_SECRET")
    },
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "78ce9fc2-7819-4929-b21a-2c3746f138ad",
        [Brands.BUNTE]: "78ce9fc2-7819-4929-b21a-2c3746f138ad"
      }
    }
  },
  production: {
    cdn: {
      hashSecret: getEnvVariable("AKAMAI_HASH_SHARED_SECRET")
    },
    legacy: {
      defaultImageId: {
        [Brands.FOCUS]: "3de37fde-807d-41fb-9296-9a22bc9ede43",
        [Brands.BUNTE]: "4c1b4694-4e82-48e6-af97-21ae4e68936a"
      }
    }
  }
});
({
  base: {
    aiva: {
      xApiKey: getEnvVariableDefault("AIVA_WEB_API_KEY", "")
    },
    chip: {
      webApiUsername: getEnvVariableDefault("CHIP_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("CHIP_WEB_API_PASSWORD", "")
    },
    bunte: {
      webApiUsername: getEnvVariableDefault("BUNTE_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("BUNTE_WEB_API_PASSWORD", "")
    }
  },
  sandbox: {
    sns: {
      alertQueueUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/legacy_push_alerts_queue${getEnvVariableDefault("BRANCH_SANDBOX_NAME", "")}`,
      topicArn: getEnvVariableDefault("SNS_TOPIC_ARN", "")
    },
    chip: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_EVENTS_QUEUE_NAME", "chip_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_EVENTS_DLQUEUE_NAME", "chip_events_dlqueue")}`,
      webApi: `https://${getEnvVariableDefault("BRANCH_SANDBOX_NAME", "")}legacy-cms-mock-server.bf-ctf-sandbox.aws.bfops.io/hooks/push`,
      webApiUsername: getEnvVariableDefault("CHIP_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("CHIP_WEB_API_PASSWORD", "")
    },
    bunte: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_EVENTS_QUEUE_NAME", "bunte_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_EVENTS_DLQUEUE_NAME", "bunte_events_dlqueue")}`,
      webApi: `https://${getEnvVariableDefault("BRANCH_SANDBOX_NAME", "")}legacy-cms-mock-server.bf-ctf-sandbox.aws.bfops.io/hooks/push`,
      webApiUsername: getEnvVariableDefault("BUNTE_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("BUNTE_WEB_API_PASSWORD", "")
    },
    fitforfun: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FITFORFUN_EVENTS_QUEUE_NAME", "fitforfun_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FITFORFUN_EVENTS_DLQUEUE_NAME", "fitforfun_events_dlqueue")}`
    },
    legacyImport: {
      sns: {
        topicArn: getEnvVariableDefault("SNS_IMPORT_TOPIC_ARN", "")
      },
      chip: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "chip_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "chip_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_archive_events_dlqueue")}`
      },
      bunte: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "bunte_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_s3_archive_events_dlqueue")}`
      },
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "focus_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "focus_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_archive_events_dlqueue")}`
      }
    },
    conversario: {
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault("FOCUS_CONVERSARIO_EVENTS_QUEUE_NAME", "focus_conversario_events_queue")}`
      }
    }
  },
  development: {
    sns: {
      topicArn: getEnvVariableDefault("SNS_TOPIC_ARN", "")
    },
    aiva: {
      xApiKey: getEnvVariableDefault("AIVA_WEB_API_KEY", "")
    },
    chip: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_EVENTS_QUEUE_NAME", "chip_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_EVENTS_DLQUEUE_NAME", "chip_events_dlqueue")}`,
      webApiUsername: getEnvVariableDefault("CHIP_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("CHIP_WEB_API_PASSWORD", "")
    },
    bunte: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_EVENTS_QUEUE_NAME", "bunte_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_EVENTS_DLQUEUE_NAME", "bunte_events_dlqueue")}`,
      webApiUsername: getEnvVariableDefault("BUNTE_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("BUNTE_WEB_API_PASSWORD", "")
    },
    fitforfun: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FITFORFUN_EVENTS_QUEUE_NAME", "fitforfun_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FITFORFUN_EVENTS_DLQUEUE_NAME", "fitforfun_events_dlqueue")}`
    },
    legacyImport: {
      sns: {
        topicArn: getEnvVariableDefault("SNS_IMPORT_TOPIC_ARN", "")
      },
      chip: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "chip_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "chip_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_archive_events_dlqueue")}`
      },
      bunte: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "bunte_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_s3_archive_events_dlqueue")}`
      },
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "focus_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "focus_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_archive_events_dlqueue")}`
      }
    },
    conversario: {
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault("FOCUS_CONVERSARIO_EVENTS_QUEUE_NAME", "focus_conversario_events_queue")}`
      }
    }
  },
  staging: {
    sns: {
      topicArn: getEnvVariableDefault("SNS_TOPIC_ARN", "")
    },
    chip: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_EVENTS_QUEUE_NAME", "chip_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_EVENTS_DLQUEUE_NAME", "chip_events_dlqueue")}`,
      webApiUsername: getEnvVariableDefault("CHIP_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("CHIP_WEB_API_PASSWORD", "")
    },
    bunte: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_EVENTS_QUEUE_NAME", "bunte_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_EVENTS_DLQUEUE_NAME", "bunte_events_dlqueue")}`,
      webApiUsername: getEnvVariableDefault("BUNTE_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("BUNTE_WEB_API_PASSWORD", "")
    },
    fitforfun: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FITFORFUN_EVENTS_QUEUE_NAME", "fitforfun_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FITFORFUN_EVENTS_DLQUEUE_NAME", "fitforfun_events_dlqueue")}`
    },
    legacyImport: {
      sns: {
        topicArn: getEnvVariableDefault("SNS_IMPORT_TOPIC_ARN", "")
      },
      chip: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "chip_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "chip_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_archive_events_dlqueue")}`
      },
      bunte: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "bunte_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_s3_archive_events_dlqueue")}`
      },
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "focus_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "focus_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_archive_events_dlqueue")}`
      }
    },
    conversario: {
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault("FOCUS_CONVERSARIO_EVENTS_QUEUE_NAME", "focus_conversario_events_queue")}`
      }
    }
  },
  production: {
    sns: {
      topicArn: getEnvVariableDefault("SNS_TOPIC_ARN", "")
    },
    chip: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_EVENTS_QUEUE_NAME", "chip_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_EVENTS_DLQUEUE_NAME", "chip_events_dlqueue")}`,
      webApiUsername: getEnvVariableDefault("CHIP_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("CHIP_WEB_API_PASSWORD", "")
    },
    bunte: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_EVENTS_QUEUE_NAME", "bunte_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_EVENTS_DLQUEUE_NAME", "bunte_events_dlqueue")}`,
      webApiUsername: getEnvVariableDefault("BUNTE_WEB_API_USERNAME", ""),
      webApiPassword: getEnvVariableDefault("BUNTE_WEB_API_PASSWORD", "")
    },
    fitforfun: {
      sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FITFORFUN_EVENTS_QUEUE_NAME", "fitforfun_events_queue")}`,
      dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FITFORFUN_EVENTS_DLQUEUE_NAME", "fitforfun_events_dlqueue")}`
    },
    legacyImport: {
      sns: {
        topicArn: getEnvVariableDefault("SNS_IMPORT_TOPIC_ARN", "")
      },
      chip: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "chip_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "chip_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "chip_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "chip_legacy_import_s3_archive_events_dlqueue")}`
      },
      bunte: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "bunte_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "bunte_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "bunte_legacy_import_s3_archive_events_dlqueue")}`
      },
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_QUEUE_NAME", "focus_legacy_import_events_queue")}`,
        dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_EVENTS_DLQUEUE_NAME", "focus_legacy_import_events_dlqueue")}`,
        sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_events_queue")}`,
        dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_events_dlqueue")}`,
        sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME", "focus_legacy_import_s3_archive_events_queue")}`,
        dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME", "focus_legacy_import_s3_archive_events_dlqueue")}`
      }
    },
    conversario: {
      focus: {
        sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault("FOCUS_CONVERSARIO_EVENTS_QUEUE_NAME", "focus_conversario_events_queue")}`
      }
    }
  }
});
const definition = {
  base: {
    apiRateLimit: {
      window: 5 * 60 * 1e3,
      // 5 minutes in milliseconds
      count: 2e3
    },
    apiUploads: {
      jsonPayload: 50 * 1024 * 1024,
      // 50 MiB in bytes,
      multipartFormFile: 10 * 1024 * 1024
      // 10 MiB in bytes,
    },
    backend: {
      remoteImageDownload: 10 * 1024 * 1024
      // 10 MiB in bytes,
    }
  },
  local: {},
  local_e2e: {},
  test: {},
  development: {},
  sandbox: {},
  staging: {},
  production: {}
};
const frameworkLimitsConfig = () => getEnvironmentConfig(definition);
var Databases;
(function(Databases2) {
  Databases2["system"] = "system";
  Databases2["editor"] = "editor";
  Databases2["federatedDbS3Bunte"] = "federatedDbS3Bunte";
  Databases2["federatedDbS3Chip"] = "federatedDbS3Chip";
  Databases2["federatedDbS3Focus"] = "federatedDbS3Focus";
  Databases2["content"] = "content";
})(Databases || (Databases = {}));
({
  base: {
    [Databases.content]: {
      host: getEnvVariableDefault("MONGODB_HOST", "").replace("mongodb+srv://", "").replace("mongodb://", ""),
      port: getEnvVariable("MONGODB_PORT"),
      username: getEnvVariable("MONGODB_USERNAME_CONTENT"),
      password: getEnvVariable("MONGODB_PASSWORD_CONTENT")
    },
    [Databases.system]: {
      host: getEnvVariableDefault("MONGODB_HOST", "").replace("mongodb+srv://", "").replace("mongodb://", ""),
      port: getEnvVariable("MONGODB_PORT"),
      username: getEnvVariable("MONGODB_USERNAME_SYSTEM"),
      password: getEnvVariable("MONGODB_PASSWORD_SYSTEM")
    },
    [Databases.editor]: {
      host: getEnvVariableDefault("MONGODB_HOST", "").replace("mongodb+srv://", "").replace("mongodb://", ""),
      port: getEnvVariable("MONGODB_PORT"),
      username: getEnvVariable("MONGODB_USERNAME_EDITOR"),
      password: getEnvVariable("MONGODB_PASSWORD_EDITOR")
    },
    [Databases.federatedDbS3Bunte]: {
      host: getEnvVariableDefault("MONGODB_HOST_FEDERATED_BUNTE", "").replace("mongodb+srv://", "").replace("mongodb://", ""),
      port: getEnvVariable("MONGODB_PORT"),
      username: getEnvVariable("MONGODB_USERNAME_FEDERATED"),
      password: getEnvVariable("MONGODB_PASSWORD_FEDERATED")
    },
    [Databases.federatedDbS3Chip]: {
      host: getEnvVariableDefault("MONGODB_HOST_FEDERATED_CHIP", "").replace("mongodb+srv://", "").replace("mongodb://", ""),
      port: getEnvVariable("MONGODB_PORT"),
      username: getEnvVariable("MONGODB_USERNAME_FEDERATED"),
      password: getEnvVariable("MONGODB_PASSWORD_FEDERATED")
    },
    [Databases.federatedDbS3Focus]: {
      host: getEnvVariableDefault("MONGODB_HOST_FEDERATED_FOCUS", "").replace("mongodb+srv://", "").replace("mongodb://", ""),
      port: getEnvVariable("MONGODB_PORT"),
      username: getEnvVariable("MONGODB_USERNAME_FEDERATED"),
      password: getEnvVariable("MONGODB_PASSWORD_FEDERATED")
    },
    databases: Object.values(Databases)
  },
  local: {
    [Databases.content]: {},
    [Databases.system]: {},
    [Databases.editor]: {},
    [Databases.federatedDbS3Bunte]: {},
    [Databases.federatedDbS3Chip]: {},
    [Databases.federatedDbS3Focus]: {}
  },
  local_e2e: {
    [Databases.content]: {},
    [Databases.system]: {},
    [Databases.editor]: {},
    [Databases.federatedDbS3Bunte]: {},
    [Databases.federatedDbS3Chip]: {},
    [Databases.federatedDbS3Focus]: {}
  },
  staging: {
    [Databases.federatedDbS3Chip]: {},
    [Databases.federatedDbS3Focus]: {}
  },
  test: {
    [Databases.content]: {},
    [Databases.system]: {},
    [Databases.editor]: {},
    [Databases.federatedDbS3Bunte]: {},
    [Databases.federatedDbS3Chip]: {},
    [Databases.federatedDbS3Focus]: {}
  }
});
({
  sandbox: {
    domain: getFeatureBranchPrefix() ? `https://${getFeatureBranchPrefix()}ctf-vibe.bf-ctf-sandbox.aws.bfops.io` : "https://api.sandbox-vibe.burda-forward.de"
    // main sandbox
  }
});
({
  base: {
    redis: {
      url: getEnvVariableDefault("REDIS_URL", "")
    }
  },
  development: {
    xymaticCredentials: {
      username: getEnvVariable("XYMATIC_CP2_USER"),
      password: getEnvVariable("XYMATIC_CP2_PASSWORD")
    }
  },
  sandbox: {
    cpServiceUrl: `https://${getFeatureBranchPrefix()}ctf-cp2.bf-ctf-sandbox.aws.bfops.io`,
    xymaticCredentials: {
      username: getEnvVariable("XYMATIC_CP2_USER"),
      password: getEnvVariable("XYMATIC_CP2_PASSWORD")
    }
  },
  staging: {
    xymaticCredentials: {
      username: getEnvVariable("XYMATIC_CP2_USER"),
      password: getEnvVariable("XYMATIC_CP2_PASSWORD")
    }
  },
  production: {
    xymaticCredentials: {
      username: getEnvVariable("XYMATIC_CP2_USER"),
      password: getEnvVariable("XYMATIC_CP2_PASSWORD")
    }
  }
});
({
  base: {
    version: getEnvVariableDefault("APP_CORE_VERSION", "local"),
    cors: {
      whitelist: ((_a = getEnvVariable("APP_CORE_CORS_WHITELIST")) == null ? void 0 : _a.split(",").map((s) => s.trim())) || []
    },
    csrf: {
      enabled: getEnvVariableDefault("APP_CORE_CSRF_ENABLED", "false") === "true",
      secret: getEnvVariableDefault("APP_CORE_CSRF_SECRET", "ctfcsrfsecret")
    },
    sso: {
      providerURL: getEnvVariableDefault("APP_CORE_SSO_PROVIDER_URL", ""),
      scope: getEnvVariableDefault("APP_CORE_SSO_SCOPE", ""),
      clientID: getEnvVariableDefault("APP_CORE_SSO_CLIENT_ID", ""),
      clientSecret: getEnvVariableDefault("APP_CORE_SSO_CLIENT_SECRET", ""),
      redirectURL: getEnvVariableDefault("APP_CORE_SSO_REDIRECT_URL", "")
    },
    redis: {
      url: getEnvVariableDefault("REDIS_URL", "")
    }
  }
});
({
  sandbox: {
    // no legacyOrigin on Sandbox (legacy mock server in use)
    bunte: {
      origin: `https://${getFeatureBranchPrefix()}bunte.bf-ctf-sandbox.aws.bfops.io`,
      legacyOrigin: `https://${getFeatureBranchPrefix()}bunte.bf-ctf-sandbox.aws.bfops.io`
    },
    chip: {
      origin: `https://${getFeatureBranchPrefix()}chip.bf-ctf-sandbox.aws.bfops.io`,
      legacyOrigin: `https://${getFeatureBranchPrefix()}chip.bf-ctf-sandbox.aws.bfops.io`
    },
    focus: {
      origin: `https://${getFeatureBranchPrefix()}focus.bf-ctf-sandbox.aws.bfops.io`,
      legacyOrigin: `https://${getFeatureBranchPrefix()}focus.bf-ctf-sandbox.aws.bfops.io`
    },
    fitforfun: {
      origin: `https://${getFeatureBranchPrefix()}fitforfun.bf-ctf-sandbox.aws.bfops.io`,
      legacyOrigin: `https://${getFeatureBranchPrefix()}fitforfun.bf-ctf-sandbox.aws.bfops.io`
    }
  }
});
getImmutableConfig({
  bunte: "550e8400-e29b-41d4-a716-446655440001",
  chip: "550e8400-e29b-41d4-a716-446655440002",
  focus: "550e8400-e29b-41d4-a716-446655440003"
});
({
  development: {
    apiUrl: getEnvVariable("CA_API_URL"),
    apiKeyAdmin: getEnvVariable("CA_API_KEY_ADMIN"),
    apiKeyGuest: getEnvVariable("CA_API_KEY_GUEST"),
    kim: {
      apiUrl: getEnvVariable("CA_KIM_API_URL"),
      apiToken: getEnvVariable("CA_KIM_API_KEY")
    }
  },
  sandbox: {
    apiUrl: getEnvVariable("CA_API_URL"),
    apiKeyAdmin: getEnvVariable("CA_API_KEY_ADMIN"),
    apiKeyGuest: getEnvVariable("CA_API_KEY_GUEST"),
    kim: {
      apiUrl: getEnvVariable("CA_KIM_API_URL"),
      apiToken: getEnvVariable("CA_KIM_API_KEY")
    }
  },
  staging: {
    apiUrl: getEnvVariable("CA_API_URL"),
    apiKeyAdmin: getEnvVariable("CA_API_KEY_ADMIN"),
    apiKeyGuest: getEnvVariable("CA_API_KEY_GUEST"),
    kim: {
      apiUrl: getEnvVariable("CA_KIM_API_URL"),
      apiToken: getEnvVariable("CA_KIM_API_KEY")
    }
  },
  production: {
    apiUrl: getEnvVariable("CA_API_URL"),
    apiKeyAdmin: getEnvVariable("CA_API_KEY_ADMIN"),
    apiKeyGuest: getEnvVariable("CA_API_KEY_GUEST"),
    kim: {
      apiUrl: getEnvVariable("CA_KIM_API_URL"),
      apiToken: getEnvVariable("CA_KIM_API_KEY")
    }
  }
});
({
  base: {
    apiKey: getEnvVariableDefault("CONVERSARIO_KEY", "")
  },
  production: {
    apiKey: getEnvVariableDefault("CONVERSARIO_KEY", "")
  }
});
var InpageWidgetVendors;
(function(InpageWidgetVendors2) {
  InpageWidgetVendors2["DPA"] = "DPA";
  InpageWidgetVendors2["DATAWRAPPER"] = "Datawrapper";
  InpageWidgetVendors2["FINANZEN"] = "Finanzen.de";
  InpageWidgetVendors2["TENNISNET"] = "Tennisnet";
  InpageWidgetVendors2["MOTORSPORT_TOTAL"] = "Motorsport Total";
  InpageWidgetVendors2["NORDBAYERN"] = "Nordbayern";
  InpageWidgetVendors2["DAA"] = "DAA";
  InpageWidgetVendors2["AROUNDHOME"] = "Aroundhome";
  InpageWidgetVendors2["COMADS"] = "CommunicationAds";
  InpageWidgetVendors2["SMAVA"] = "Smava";
  InpageWidgetVendors2["BAUFI24"] = "Baufi24";
  InpageWidgetVendors2["CALCULATORTOOLS"] = "CalculatorTools";
  InpageWidgetVendors2["CIVEY"] = "Civey";
  InpageWidgetVendors2["OFFERISTA"] = "Offerista";
  InpageWidgetVendors2["OPINARY"] = "Opinary";
  InpageWidgetVendors2["SPEEDTEST"] = "Speedtest";
  InpageWidgetVendors2["TRACDELIGHT"] = "Tracdelight";
})(InpageWidgetVendors || (InpageWidgetVendors = {}));
({
  [InpageWidgetVendors.DPA]: "dpa",
  [InpageWidgetVendors.DATAWRAPPER]: "datawrapper",
  [InpageWidgetVendors.FINANZEN]: "finanzen",
  [InpageWidgetVendors.TENNISNET]: "tennisnet",
  [InpageWidgetVendors.MOTORSPORT_TOTAL]: "motorsportTotal",
  [InpageWidgetVendors.NORDBAYERN]: "nordbayern",
  [InpageWidgetVendors.DAA]: "daa",
  [InpageWidgetVendors.AROUNDHOME]: "aroundhome",
  [InpageWidgetVendors.COMADS]: "comads",
  [InpageWidgetVendors.SMAVA]: "smava",
  [InpageWidgetVendors.BAUFI24]: "baufi24",
  [InpageWidgetVendors.CALCULATORTOOLS]: "calculatortools",
  [InpageWidgetVendors.CIVEY]: "civey",
  [InpageWidgetVendors.OFFERISTA]: "offerista",
  [InpageWidgetVendors.OPINARY]: "opinary",
  [InpageWidgetVendors.SPEEDTEST]: "speedtest",
  [InpageWidgetVendors.TRACDELIGHT]: "tracdelight"
});
({
  datawrapper: {
    vendor: InpageWidgetVendors.DATAWRAPPER
  },
  dpa: {
    vendor: InpageWidgetVendors.DPA
  },
  finanzen: {
    vendor: InpageWidgetVendors.FINANZEN
  },
  tennisnet: {
    vendor: InpageWidgetVendors.TENNISNET
  },
  motorsportTotal: {
    vendor: InpageWidgetVendors.MOTORSPORT_TOTAL
  },
  nordbayern: {
    vendor: InpageWidgetVendors.NORDBAYERN
  },
  daa: {
    vendor: InpageWidgetVendors.DAA
  },
  aroundhome: {
    vendor: InpageWidgetVendors.AROUNDHOME
  },
  comads: {
    vendor: InpageWidgetVendors.COMADS
  },
  smava: {
    vendor: InpageWidgetVendors.SMAVA
  },
  baufi24: {
    vendor: InpageWidgetVendors.BAUFI24
  },
  calculatortools: {
    vendor: InpageWidgetVendors.CALCULATORTOOLS
  },
  civey: {
    vendor: InpageWidgetVendors.CIVEY
  },
  offerista: {
    vendor: InpageWidgetVendors.OFFERISTA
  },
  opinary: {
    vendor: InpageWidgetVendors.OPINARY
  },
  speedtest: {
    vendor: InpageWidgetVendors.SPEEDTEST
  },
  tracdelight: {
    vendor: InpageWidgetVendors.TRACDELIGHT
  }
});
({
  base: {
    brandConfig: {
      ...getEnvVariable("CLEVERPUSH_API_KEY_FOCUS") ? {
        focus: {
          authorizationKey: getEnvVariable("CLEVERPUSH_API_KEY_FOCUS"),
          recipientsSource: "topics",
          cleverpushChannelWhitelist: ["cXyiFj3QoYM8nNy2d"],
          cleverpushRecipientBlacklist: ["TCNLzxNAcvQEJgMzJ"],
          breakingNewsConfig: {
            targetRecipients: ["RgeMGpJ52MnKQd8PY"]
          }
        }
      } : {},
      ...getEnvVariable("CLEVERPUSH_API_KEY_BUNTE") ? {
        bunte: {
          authorizationKey: getEnvVariable("CLEVERPUSH_API_KEY_BUNTE"),
          recipientsSource: "tags",
          breakingNewsConfig: {
            targetRecipients: ["kg4YKoxZ7qrR37veK"]
          }
        }
      } : {}
    }
  },
  production: {
    brandConfig: {
      ...getEnvVariable("CLEVERPUSH_API_KEY_FOCUS") ? {
        focus: {
          authorizationKey: getEnvVariable("CLEVERPUSH_API_KEY_FOCUS"),
          recipientsSource: "topics",
          cleverpushChannelWhitelist: ["tpt96Yabt79qgxJYK"],
          //APP channel - PRODUCTION ID
          cleverpushRecipientBlacklist: ["muWcihzspgb52EpvT"],
          //Filtering out Sportlive - PRODUCTION ID
          breakingNewsConfig: {
            cleverpushChannelWhitelist: ["6ST4phB33NWhSfWrC", "tpt96Yabt79qgxJYK"],
            //WEB and APP channel - PRODUCTION ID
            targetRecipients: ["eeXC9sCuvYmN2L4mm"]
            //Breaking news - PRODUCTION ID
          }
        }
      } : {},
      ...getEnvVariable("CLEVERPUSH_API_KEY_BUNTE") ? {
        bunte: {
          authorizationKey: getEnvVariable("CLEVERPUSH_API_KEY_BUNTE"),
          recipientsSource: "tags",
          cleverpushChannelWhitelist: ["JEmqXMZbDqfokooJX", "DQcMnJ36q2LZTjeAM", "NQMurDdbzBCpdtHvA"],
          // Two APP channels and Web - PRODUCTION ID
          cleverpushRecipientWhitelist: ["e2uJtDG4xoJ2LoRZC", "CBcmm9oBmWw7cTBv4"],
          //Breaking news and Royals - PRODUCTION IDs
          breakingNewsConfig: {
            cleverpushChannelWhitelist: ["JEmqXMZbDqfokooJX", "DQcMnJ36q2LZTjeAM", "NQMurDdbzBCpdtHvA"],
            // Two APP channels and Web - PRODUCTION ID
            targetRecipients: ["e2uJtDG4xoJ2LoRZC"]
            //Breaking news - PRODUCTION IDs
          }
        }
      } : {}
    }
  }
});
const _sfc_main$3 = {};
const _hoisted_1$3 = { class: "flex flex-center placeholder" };
function _sfc_render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$3);
}
const EditorImagePlaceholder = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-a0c1365f"], ["__file", "/builds/CT/content-technology-framework/modules/image/editor-ui/src/components/editor-image-placeholder.vue"]]);
const stateChangeIn = (imageDate) => {
  const scheduledIn = imageDate ? imageDate.getTime() : 1;
  return Math.ceil((scheduledIn - Date.now()) / (1e3 * 60 * 60 * 24));
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "editor-image-state-overlay",
  props: {
    image: { type: Object, required: true },
    entity: { type: String, required: false, default: void 0 },
    showMsgInTooltip: { type: Boolean, required: false, default: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const props = __props;
    const onlineIn = computed(() => stateChangeIn(props.image.publishDate));
    const expireIn = computed(() => stateChangeIn(props.image.unpublishDate));
    const __returned__ = { t, props, onlineIn, expireIn, get StatusIcon() {
      return StatusIcon;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$2 = {
  key: 0,
  class: "absolute-full flex flex-center"
};
const _hoisted_2$2 = { class: "relative-center text-subtitle2 image-overlay-label text-dark" };
const _hoisted_3$2 = ["textContent"];
const _hoisted_4$2 = {
  key: 1,
  class: "absolute-top-left text-subtitle2 image-overlay-label q-ml-xs q-mt-xs text-dark"
};
const _hoisted_5$1 = ["textContent"];
const _hoisted_6$1 = {
  key: 2,
  class: "absolute-top-left text-subtitle2 image-overlay-label q-ml-xs q-mt-xs text-dark"
};
const _hoisted_7$1 = ["textContent"];
const _hoisted_8$1 = {
  key: 3,
  class: "absolute-full flex flex-center"
};
const _hoisted_9$1 = { class: "relative-center text-subtitle2 image-overlay-label text-dark" };
const _hoisted_10$1 = ["textContent"];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      $props.image.state === "draft" && $props.entity !== "video" ? (openBlock(), createElementBlock("div", _hoisted_1$2, [
        createElementVNode("div", _hoisted_2$2, [
          createVNode($setup["StatusIcon"], {
            value: "edit-3",
            class: "image-overlay-icon text-grey"
          }),
          $props.showMsgInTooltip ? (openBlock(), createBlock($setup["QTooltip"], {
            key: 0,
            anchor: "top middle",
            self: "bottom middle",
            class: "text-white bg-black",
            offset: [5, 5]
          }, {
            default: withCtx(() => [
              createTextVNode(
                toDisplayString($setup.t("images.components.imageDraft")),
                1
                /* TEXT */
              )
            ]),
            _: 1
            /* STABLE */
          })) : (openBlock(), createElementBlock("span", {
            key: 1,
            class: "q-ml-xs",
            textContent: toDisplayString($setup.t("images.components.imageDraft"))
          }, null, 8, _hoisted_3$2))
        ])
      ])) : createCommentVNode("v-if", true),
      $props.image.state === "schedule" && $props.entity !== "video" ? (openBlock(), createElementBlock("div", _hoisted_4$2, [
        createVNode($setup["StatusIcon"], {
          value: "clock",
          class: "image-overlay-icon text-light-blue"
        }),
        $props.showMsgInTooltip ? (openBlock(), createBlock($setup["QTooltip"], {
          key: 0,
          anchor: "top middle",
          self: "bottom middle",
          class: "text-white bg-black",
          offset: [5, 5]
        }, {
          default: withCtx(() => [
            createTextVNode(
              toDisplayString($setup.t("images.components.imagePublish", { n: $setup.onlineIn })),
              1
              /* TEXT */
            )
          ]),
          _: 1
          /* STABLE */
        })) : (openBlock(), createElementBlock("span", {
          key: 1,
          class: "q-ml-xs",
          textContent: toDisplayString($setup.t("components.imagePublish", { n: $setup.onlineIn }))
        }, null, 8, _hoisted_5$1))
      ])) : createCommentVNode("v-if", true),
      $props.image.state === "publish" && $props.image.unpublishDate && $props.entity !== "video" ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
        createVNode($setup["StatusIcon"], {
          value: "clock",
          class: "image-overlay-icon text-red"
        }),
        $props.showMsgInTooltip ? (openBlock(), createBlock($setup["QTooltip"], {
          key: 0,
          anchor: "top middle",
          self: "bottom middle",
          class: "text-white bg-black",
          offset: [5, 5]
        }, {
          default: withCtx(() => [
            createTextVNode(
              toDisplayString($setup.t("images.components.imageExpiresIn", { n: $setup.expireIn })),
              1
              /* TEXT */
            )
          ]),
          _: 1
          /* STABLE */
        })) : (openBlock(), createElementBlock("span", {
          key: 1,
          class: "q-ml-xs",
          textContent: toDisplayString($setup.t("components.imageExpiresIn", { n: $setup.expireIn }))
        }, null, 8, _hoisted_7$1))
      ])) : createCommentVNode("v-if", true),
      $props.image.state === "unpublish" && $props.entity !== "video" ? (openBlock(), createElementBlock("div", _hoisted_8$1, [
        createElementVNode("div", _hoisted_9$1, [
          createVNode($setup["StatusIcon"], {
            value: "alert-circle",
            class: "image-overlay-icon text-red"
          }),
          $props.showMsgInTooltip ? (openBlock(), createBlock($setup["QTooltip"], {
            key: 0,
            anchor: "top middle",
            self: "bottom middle",
            class: "text-white bg-black",
            offset: [5, 5]
          }, {
            default: withCtx(() => [
              createTextVNode(
                toDisplayString($setup.t("images.components.imageExpired")),
                1
                /* TEXT */
              )
            ]),
            _: 1
            /* STABLE */
          })) : (openBlock(), createElementBlock("span", {
            key: 1,
            class: "q-ml-xs",
            textContent: toDisplayString($setup.t("images.components.imageExpired"))
          }, null, 8, _hoisted_10$1))
        ])
      ])) : createCommentVNode("v-if", true)
    ],
    64
    /* STABLE_FRAGMENT */
  );
}
const EditorImageStateOverlay = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-e7f2728b"], ["__file", "/builds/CT/content-technology-framework/modules/image/editor-ui/src/components/editor-image-state-overlay.vue"]]);
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var eventemitter3 = { exports: {} };
(function(module) {
  var has = Object.prototype.hasOwnProperty, prefix = "~";
  function Events() {
  }
  if (Object.create) {
    Events.prototype = /* @__PURE__ */ Object.create(null);
    if (!new Events().__proto__)
      prefix = false;
  }
  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }
  function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") {
      throw new TypeError("The listener must be a function");
    }
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt])
      emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn)
      emitter._events[evt].push(listener);
    else
      emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0)
      emitter._events = new Events();
    else
      delete emitter._events[evt];
  }
  function EventEmitter2() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  EventEmitter2.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0)
      return names;
    for (name in events = this._events) {
      if (has.call(events, name))
        names.push(prefix ? name.slice(1) : name);
    }
    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }
    return names;
  };
  EventEmitter2.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers)
      return [];
    if (handlers.fn)
      return [handlers.fn];
    for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
      ee[i] = handlers[i].fn;
    }
    return ee;
  };
  EventEmitter2.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners)
      return 0;
    if (listeners.fn)
      return 1;
    return listeners.length;
  };
  EventEmitter2.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
      if (listeners.once)
        this.removeListener(event, listeners.fn, void 0, true);
      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;
        case 2:
          return listeners.fn.call(listeners.context, a1), true;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }
      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }
      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length, j;
      for (i = 0; i < length; i++) {
        if (listeners[i].once)
          this.removeListener(event, listeners[i].fn, void 0, true);
        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;
          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;
          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;
          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;
          default:
            if (!args)
              for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }
    return true;
  };
  EventEmitter2.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
  };
  EventEmitter2.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
  };
  EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return this;
    if (!fn) {
      clearEvent(this, evt);
      return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }
      if (events.length)
        this._events[evt] = events.length === 1 ? events[0] : events;
      else
        clearEvent(this, evt);
    }
    return this;
  };
  EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt])
        clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }
    return this;
  };
  EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
  EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
  EventEmitter2.prefixed = prefix;
  EventEmitter2.EventEmitter = EventEmitter2;
  {
    module.exports = EventEmitter2;
  }
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
const bus = new EventEmitter();
const useImageEventBus = () => bus;
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "image-list.selector",
  props: {
    label: { type: String, required: false, default: void 0 },
    imgData: { type: Object, required: false, default: void 0 },
    modelValue: { type: String, required: false, default: void 0 },
    disable: { type: Boolean, required: false, default: false },
    isSquare: { type: Boolean, required: false, default: false },
    required: { type: Boolean, required: false, default: false },
    state: { type: String, required: false, default: void 0 },
    license: { type: null, required: false, default: void 0 },
    rules: { type: Array, required: false, default: void 0 },
    horizontal: { type: Boolean, required: false, default: true },
    type: { type: String, required: false, default: void 0 },
    selectedBrand: { type: null, required: false, default: void 0 },
    disableBrand: { type: Boolean, required: false, default: false },
    selectedImageList: { type: Array, required: false, default: void 0 },
    multi: { type: Boolean, required: false, default: false },
    showPartnerImages: { type: Boolean, required: false, default: false },
    showPartnerImagesFilter: { type: Boolean, required: false, default: false }
  },
  emits: ["update:image", "update:imageMulti", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const ImageEdit = defineAsyncComponent(() => import("./image-edit-BJMa_0Fb.js"));
    const ImageList = defineAsyncComponent(() => import("./image-list-C-rMneAV.js"));
    const props = __props;
    const emit = __emit;
    const eventBus = useImageEventBus();
    const getEmptyDocument = () => ({
      _id: "",
      title: "",
      source: "",
      state: "draft",
      caption: "",
      credits: "",
      changeDate: /* @__PURE__ */ new Date(),
      createDate: /* @__PURE__ */ new Date(),
      height: 0,
      width: 0,
      isDeleted: false,
      license: [],
      legacy: {
        source: "vibe",
        isEditableInCTF: true,
        isRenderedByCTF: true,
        hasBeenModifiedInCTF: true
      }
    });
    const ImageData = ref(getEmptyDocument());
    const wideUrl = ref("");
    const ultraWideUrl = ref("");
    const squareUrl = ref("");
    const dialogVisible = ref(false);
    const clickedNewImage = ref(false);
    const isValid = ref(true);
    const validationMsg = ref("");
    const wrapper = ref();
    const maxFileSize = frameworkLimitsConfig().apiUploads.multipartFormFile / (1024 * 1024);
    __expose({ ImageData });
    const validateRules = () => {
      const validationRulesResult = quasarValidateRules(ImageData.value, props.rules);
      isValid.value = !validationRulesResult;
      validationMsg.value = validationRulesResult;
    };
    useFormChild({
      validate() {
        var _a2;
        validateRules();
        if (!isValid.value) {
          (_a2 = wrapper.value) == null ? void 0 : _a2.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
        return isValid.value;
      },
      resetValidation() {
        isValid.value = true;
        validationMsg.value = "";
      }
    });
    const previewUrl = computed(() => props.isSquare ? squareUrl.value : wideUrl.value);
    const showDialog = () => {
      if (!props.disable) {
        dialogVisible.value = true;
      }
    };
    const imageSelected = (image) => {
      ImageData.value = image;
      clickedNewImage.value = true;
      emit("update:image", image);
      emit("update:modelValue", ImageData.value._id);
      dialogVisible.value = false;
    };
    const imageSelectedMulti = (images) => {
      emit("update:imageMulti", images);
      dialogVisible.value = false;
    };
    const { t } = useI18n();
    const tLabel = computed(() => !props.label ? t("components.imageUploadLabel", { maxFileSize }) : props.label);
    const closeModal = () => {
      dialogVisible.value = false;
      clickedNewImage.value = false;
    };
    const brand = computed(() => {
      var _a2;
      const imageLicense = ((_a2 = ImageData.value) == null ? void 0 : _a2.license) || [];
      const searchLicense = props.selectedBrand;
      let mainBrand;
      let otherBrands;
      if (searchLicense && imageLicense.includes(searchLicense)) {
        mainBrand = searchLicense;
        otherBrands = imageLicense.filter((label) => label !== searchLicense);
      } else {
        [mainBrand, ...otherBrands] = imageLicense.sort();
      }
      const tooltipText = otherBrands.sort().join(", ");
      return {
        mainBrand,
        tooltipText
      };
    });
    const clearImageData = () => {
      ImageData.value = getEmptyDocument();
      validationMsg.value = "";
      emit("update:image", void 0);
      emit("update:modelValue");
      clickedNewImage.value = false;
      closeModal();
    };
    const onSave = async (imgs) => {
      const image = imgs[0];
      if (!image) {
        return;
      }
      dialogVisible.value = false;
      ImageData.value = image;
      emit("update:modelValue", image._id);
      clickedNewImage.value = false;
      const resp = await getImage(image._id, true);
      ImageData.value = resp.image;
      squareUrl.value = resp.squarePreview || resp.image.source;
      wideUrl.value = resp.widePreview || resp.image.source;
      ultraWideUrl.value = resp.ultraWidePreview || resp.image.source;
      emit("update:image", resp.image);
    };
    eventBus.on("updateImage", async (image) => {
      var _a2;
      if (image._id === ((_a2 = props.imgData) == null ? void 0 : _a2._id)) {
        ImageData.value = image;
        validateRules();
        squareUrl.value = image.source;
        wideUrl.value = image.source;
        ultraWideUrl.value = image.source;
        return;
      }
      if (props.modelValue === image._id) {
        const resp = await getImage(props.modelValue, true);
        ImageData.value = resp.image;
        validateRules();
        squareUrl.value = resp.squarePreview || resp.image.source;
        wideUrl.value = resp.widePreview || resp.image.source;
        ultraWideUrl.value = resp.ultraWidePreview || resp.image.source;
      }
    });
    onBeforeMount(async () => {
      if (props.imgData) {
        ImageData.value = props.imgData;
        squareUrl.value = props.imgData.source;
        wideUrl.value = props.imgData.source;
        ultraWideUrl.value = props.imgData.source;
        return;
      }
      if (props.modelValue) {
        const resp = await getImage(props.modelValue, true);
        ImageData.value = resp.image;
        squareUrl.value = resp.squarePreview || resp.image.source;
        wideUrl.value = resp.widePreview || resp.image.source;
        ultraWideUrl.value = resp.ultraWidePreview || resp.image.source;
      }
    });
    watch(
      () => props.modelValue,
      async () => {
        if (props.modelValue) {
          const resp = await getImage(props.modelValue, true);
          ImageData.value = resp.image;
          squareUrl.value = resp.squarePreview || resp.image.source;
          wideUrl.value = resp.widePreview || resp.image.source;
          ultraWideUrl.value = resp.ultraWidePreview || resp.image.source;
        } else {
          ImageData.value = getEmptyDocument();
        }
        validationMsg.value = "";
      },
      { deep: true, immediate: true }
    );
    const __returned__ = { ImageEdit, ImageList, props, emit, eventBus, getEmptyDocument, ImageData, wideUrl, ultraWideUrl, squareUrl, dialogVisible, clickedNewImage, isValid, validationMsg, wrapper, maxFileSize, validateRules, previewUrl, showDialog, imageSelected, imageSelectedMulti, t, tLabel, closeModal, brand, clearImageData, onSave, get PLACEHOLDER_UUID() {
      return PLACEHOLDER_UUID;
    }, get QBadge() {
      return QBadge;
    }, get QBtn() {
      return QBtn;
    }, get QCard() {
      return QCard;
    }, get QCardSection() {
      return QCardSection;
    }, get QDialog() {
      return QDialog;
    }, get QIcon() {
      return QIcon;
    }, get QImg() {
      return QImg;
    }, get QInput() {
      return QInput;
    }, get QTooltip() {
      return QTooltip;
    }, EditorImagePlaceholder, EditorImageStateOverlay };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$1 = {
  ref: "wrapper",
  class: "q-pa-none"
};
const _hoisted_2$1 = { class: "row justify-center items-center align-center text-center" };
const _hoisted_3$1 = { class: "col" };
const _hoisted_4$1 = {
  key: 0,
  class: "required"
};
const _hoisted_5 = { class: "col-12" };
const _hoisted_6 = {
  class: /* @__PURE__ */ normalizeClass(["container-wrapper"])
};
const _hoisted_7 = {
  key: 0,
  class: "row"
};
const _hoisted_8 = { class: "col" };
const _hoisted_9 = { class: "image-description" };
const _hoisted_10 = { class: "text-wrap image-list-content" };
const _hoisted_11 = { class: "text-wrap image-list-content q-ml-sm q-mr-sm q-mt-sm" };
const _hoisted_12 = { class: "text-wrap image-list-licence text-muted q-ml-sm q-mr-sm q-mb-xs" };
const _hoisted_13 = { class: "q-field__messages text-negative col" };
const _hoisted_14 = ["textContent"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1$1,
    [
      createVNode($setup["QCard"], {
        class: normalizeClass(["q-pa-none no-shadow", { invalid: !$setup.isValid }])
      }, {
        default: withCtx(() => [
          !$props.modelValue ? (openBlock(), createBlock($setup["QCardSection"], {
            key: 0,
            "data-qa-image-picker": "",
            class: normalizeClass(["custom-image-wrapper q-mt-md border-item border-item--dashed custom-add-image", { invalid: !$setup.isValid }]),
            onClick: $setup.showDialog
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_2$1, [
                createElementVNode("div", _hoisted_3$1, [
                  !$setup.ImageData.title ? (openBlock(), createBlock($setup["QIcon"], {
                    key: 0,
                    size: "36px",
                    name: "image",
                    color: "grey-5"
                  })) : createCommentVNode("v-if", true),
                  createVNode($setup["QInput"], mergeProps({
                    modelValue: $setup.ImageData.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.ImageData.title = $event),
                    class: "hidden",
                    "append-icon": "external-link",
                    clearable: "",
                    readonly: "",
                    borderless: ""
                  }, _ctx.$attrs, {
                    "onClick:clear": $setup.imageSelected,
                    "onClick:append": $setup.showDialog
                  }), null, 16, ["modelValue"]),
                  !$setup.ImageData.title ? (openBlock(), createBlock($setup["QCardSection"], {
                    key: 1,
                    "data-qa-image-title": "",
                    flat: "",
                    class: "q-pa-sm",
                    color: "white"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(
                        toDisplayString($setup.tLabel) + " ",
                        1
                        /* TEXT */
                      ),
                      $props.required ? (openBlock(), createElementBlock("span", _hoisted_4$1)) : createCommentVNode("v-if", true)
                    ]),
                    _: 1
                    /* STABLE */
                  })) : createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _: 1
            /* STABLE */
          }, 8, ["class"])) : (openBlock(), createBlock($setup["QCardSection"], {
            key: 1,
            style: { "height": "100%" },
            class: normalizeClass(["q-pa-none q-mt-md border-item", { invalid: !$setup.isValid }])
          }, {
            default: withCtx(() => [
              createElementVNode(
                "div",
                {
                  class: normalizeClass([
                    "row",
                    {
                      // eslint-disable-next-line prettier/prettier
                      column: !$props.horizontal
                    }
                  ])
                },
                [
                  createElementVNode("div", _hoisted_5, [
                    createElementVNode("div", _hoisted_6, [
                      $props.type === "image" || $setup.props.type === "video" || $props.type === "gallery" ? (openBlock(), createElementBlock("div", _hoisted_7, [
                        createElementVNode(
                          "div",
                          {
                            class: normalizeClass(["col-4", { square: $props.isSquare }])
                          },
                          [
                            $setup.ImageData._id && $setup.ImageData._id !== $setup.PLACEHOLDER_UUID ? (openBlock(), createBlock($setup["QImg"], {
                              key: 0,
                              "data-qa-preview": "",
                              class: "custom-image",
                              src: $setup.previewUrl,
                              onClick: $setup.showDialog
                            }, {
                              default: withCtx(() => [
                                $setup.ImageData ? (openBlock(), createBlock($setup["EditorImageStateOverlay"], {
                                  key: 0,
                                  image: $setup.ImageData
                                }, null, 8, ["image"])) : createCommentVNode("v-if", true)
                              ]),
                              _: 1
                              /* STABLE */
                            }, 8, ["src"])) : (openBlock(), createBlock($setup["EditorImagePlaceholder"], {
                              key: 1,
                              class: "custom-image"
                            }))
                          ],
                          2
                          /* CLASS */
                        ),
                        createElementVNode("div", _hoisted_8, [
                          createElementVNode("div", _hoisted_9, [
                            createElementVNode(
                              "div",
                              _hoisted_10,
                              toDisplayString($setup.ImageData.title),
                              1
                              /* TEXT */
                            ),
                            createElementVNode(
                              "div",
                              {
                                class: normalizeClass([{ "q-my-sm text-center c-btn": !$props.horizontal }])
                              },
                              [
                                createVNode($setup["QBtn"], {
                                  "data-qa-image-picker-remove-button": "",
                                  outline: "",
                                  color: "white",
                                  "text-color": "black",
                                  label: $setup.t("articlesEdit.remove"),
                                  class: "border-btn",
                                  disable: $props.disable,
                                  onClick: $setup.clearImageData
                                }, null, 8, ["label", "disable"]),
                                createCommentVNode("            Not for v50, but might return in the future "),
                                createCommentVNode(`            <q-banner v-if="ImageData.state !== 'publish'" rounded dense class="bg-warning q-my-xs word-wrap">`),
                                createCommentVNode("              <template #avatar>"),
                                createCommentVNode('                <q-icon name="alert-triangle" />'),
                                createCommentVNode("              </template>"),
                                createCommentVNode("              {{ t('images.components.selectorNotPublishedWarning') }}"),
                                createCommentVNode("            </q-banner>")
                              ],
                              2
                              /* CLASS */
                            )
                          ])
                        ])
                      ])) : $props.type !== "image" ? (openBlock(), createElementBlock(
                        Fragment,
                        { key: 1 },
                        [
                          $setup.ImageData._id && $setup.ImageData._id !== $setup.PLACEHOLDER_UUID ? (openBlock(), createBlock($setup["QImg"], {
                            key: 0,
                            "data-qa-preview": "",
                            class: "custom-image",
                            src: $setup.previewUrl,
                            onClick: $setup.showDialog
                          }, {
                            default: withCtx(() => [
                              $setup.ImageData ? (openBlock(), createBlock($setup["EditorImageStateOverlay"], {
                                key: 0,
                                image: $setup.ImageData
                              }, null, 8, ["image"])) : createCommentVNode("v-if", true)
                            ]),
                            _: 1
                            /* STABLE */
                          }, 8, ["src"])) : (openBlock(), createBlock($setup["EditorImagePlaceholder"], {
                            key: 1,
                            class: "custom-image"
                          })),
                          createElementVNode(
                            "div",
                            _hoisted_11,
                            toDisplayString($setup.ImageData.title),
                            1
                            /* TEXT */
                          ),
                          createElementVNode("div", _hoisted_12, [
                            createElementVNode(
                              "span",
                              null,
                              toDisplayString($setup.t("videos.license")) + ": " + toDisplayString($setup.brand.mainBrand),
                              1
                              /* TEXT */
                            ),
                            withDirectives(createVNode(
                              $setup["QBadge"],
                              {
                                color: "grey-9 image-badge",
                                "text-color": "white",
                                class: "q-mx-sm"
                              },
                              {
                                default: withCtx(() => [
                                  createTextVNode(
                                    " +" + toDisplayString($setup.ImageData.license.length - 1) + " ",
                                    1
                                    /* TEXT */
                                  ),
                                  createVNode($setup["QTooltip"], {
                                    anchor: "top middle",
                                    self: "top middle",
                                    offset: [10, 30],
                                    class: "bg-grey-10 text-white shadow-4"
                                  }, {
                                    default: withCtx(() => [
                                      createTextVNode(
                                        toDisplayString($setup.brand.tooltipText),
                                        1
                                        /* TEXT */
                                      )
                                    ]),
                                    _: 1
                                    /* STABLE */
                                  })
                                ]),
                                _: 1
                                /* STABLE */
                              },
                              512
                              /* NEED_PATCH */
                            ), [
                              [vShow, $setup.brand.tooltipText]
                            ])
                          ]),
                          createElementVNode(
                            "div",
                            {
                              class: normalizeClass(["col q-mx-md", { "q-my-sm text-center c-btn": !$props.horizontal }])
                            },
                            [
                              createVNode($setup["QBtn"], {
                                "data-qa-image-picker-remove-button": "",
                                outline: "",
                                color: "white",
                                "text-color": "black",
                                label: $setup.t("articlesEdit.remove"),
                                class: "border-btn",
                                disable: $props.disable,
                                onClick: $setup.clearImageData
                              }, null, 8, ["label", "disable"]),
                              createCommentVNode("            Not for v50, but might return in the future "),
                              createCommentVNode(`            <q-banner v-if="ImageData.state !== 'publish'" rounded dense class="bg-warning q-my-xs word-wrap">`),
                              createCommentVNode("              <template #avatar>"),
                              createCommentVNode('                <q-icon name="alert-triangle" />'),
                              createCommentVNode("              </template>"),
                              createCommentVNode("              {{ t('images.components.selectorNotPublishedWarning') }}"),
                              createCommentVNode("            </q-banner>")
                            ],
                            2
                            /* CLASS */
                          )
                        ],
                        64
                        /* STABLE_FRAGMENT */
                      )) : createCommentVNode("v-if", true)
                    ])
                  ])
                ],
                2
                /* CLASS */
              )
            ]),
            _: 1
            /* STABLE */
          }, 8, ["class"])),
          createCommentVNode(" Custom quasar-like validation "),
          $setup.validationMsg ? (openBlock(), createBlock($setup["QCardSection"], {
            key: 2,
            class: "q-field__bottom row items-start q-field__bottom--animated"
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_13, [
                createElementVNode("div", {
                  role: "alert",
                  textContent: toDisplayString($setup.validationMsg)
                }, null, 8, _hoisted_14)
              ])
            ]),
            _: 1
            /* STABLE */
          })) : createCommentVNode("v-if", true)
        ]),
        _: 1
        /* STABLE */
      }, 8, ["class"]),
      createVNode($setup["QDialog"], {
        modelValue: $setup.dialogVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $setup.dialogVisible = $event),
        "data-qa-image-modal": "",
        "full-width": "",
        "full-height": "",
        onHide: $setup.closeModal
      }, {
        default: withCtx(() => [
          !$props.modelValue && !$setup.clickedNewImage ? (openBlock(), createBlock($setup["ImageList"], {
            key: 0,
            dialog: true,
            state: $props.state,
            license: $props.license,
            "disable-brand": $props.disableBrand,
            "selected-image-list": $props.selectedImageList,
            multi: $props.multi,
            "show-partner-images": $props.showPartnerImages,
            "show-partner-images-filter": $props.showPartnerImagesFilter,
            "onNew:clicked": _cache[1] || (_cache[1] = ($event) => $setup.clickedNewImage = true),
            "onBack:modal": $setup.closeModal,
            onClose: $setup.clearImageData,
            "onClick:image": $setup.imageSelected,
            "onClick:imageMulti": $setup.imageSelectedMulti
          }, null, 8, ["state", "license", "disable-brand", "selected-image-list", "multi", "show-partner-images", "show-partner-images-filter"])) : !$props.modelValue ? (openBlock(), createBlock($setup["ImageEdit"], {
            key: 1,
            dialog: true,
            title: $setup.t("router.createImage"),
            "back-route": void 0,
            "onBack:modal": $setup.closeModal,
            onClose: $setup.clearImageData,
            onSaveImages: $setup.onSave
          }, null, 8, ["title"])) : (openBlock(), createBlock($setup["ImageEdit"], {
            key: 2,
            id: $props.modelValue,
            dialog: true,
            title: $setup.t("router.editImage"),
            "back-route": void 0,
            "onBack:modal": $setup.closeModal,
            onClose: $setup.clearImageData,
            onSaveImages: $setup.onSave
          }, null, 8, ["id", "title"]))
        ]),
        _: 1
        /* STABLE */
      }, 8, ["modelValue"])
    ],
    512
    /* NEED_PATCH */
  );
}
const ImageListSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-cbca6f57"], ["__file", "/builds/CT/content-technology-framework/modules/image/editor-ui/src/selectors/image-list.selector.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "image-channel-content-block",
  props: /* @__PURE__ */ mergeModels({
    license: { type: null, required: false },
    locked: { type: Boolean, required: false },
    rules: { type: Array, required: false }
  }, {
    "modelValue": { type: Object, ...{ required: true } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const channelBlockData = useModel(__props, "modelValue");
    const { t } = useI18n();
    const __returned__ = { channelBlockData, t, get BCheckbox() {
      return BCheckbox;
    }, get QIcon() {
      return QIcon;
    }, get QInput() {
      return QInput;
    }, get QTooltip() {
      return QTooltip;
    }, ImageListSelector };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = { class: "q-mt-md" };
const _hoisted_2 = { class: "row justify-content-center align-items-center q-mt-md" };
const _hoisted_3 = { class: "q-mr-md" };
const _hoisted_4 = { class: "q-mr-md" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createVNode($setup["ImageListSelector"], {
      modelValue: $setup.channelBlockData.imageUuid,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.channelBlockData.imageUuid = $event),
      "data-qa": "channel-image-stage-image-picker",
      state: "publish",
      disable: $props.locked,
      license: $props.license,
      rules: $props.rules,
      type: "image"
    }, null, 8, ["modelValue", "disable", "license", "rules"]),
    createVNode($setup["QInput"], {
      modelValue: $setup.channelBlockData.imageLinkOutUrl,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.channelBlockData.imageLinkOutUrl = $event),
      "data-qa": "channel-image-url-field",
      label: $setup.t("articleBlocks.imageUrl"),
      class: "q-mt-lg",
      placeholder: $setup.t("articleBlocks.imagePlaceholder"),
      disable: $props.locked,
      dense: "",
      outlined: ""
    }, null, 8, ["modelValue", "label", "placeholder", "disable"]),
    createElementVNode("div", _hoisted_2, [
      createElementVNode("div", _hoisted_3, [
        createVNode($setup["BCheckbox"], {
          modelValue: $setup.channelBlockData.hasNoFollow,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $setup.channelBlockData.hasNoFollow = $event),
          "data-qa": "channel-image-hasnofollow",
          class: "col-3",
          label: $setup.t("articleBlocks.noFollow"),
          dense: "",
          disable: $props.locked
        }, null, 8, ["modelValue", "label", "disable"]),
        createVNode($setup["QIcon"], {
          name: "info",
          class: "q-ml-sm"
        }, {
          default: withCtx(() => [
            createVNode($setup["QTooltip"], {
              class: "bg-grey-10 text-white shadow-4",
              "max-width": "400px",
              anchor: "top middle",
              self: "bottom middle",
              offset: [10, 10]
            }, {
              default: withCtx(() => [
                createTextVNode(
                  toDisplayString($setup.t("articleBlocks.noFollowTooltip")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            })
          ]),
          _: 1
          /* STABLE */
        })
      ]),
      createVNode($setup["BCheckbox"], {
        modelValue: $setup.channelBlockData.hasNewTab,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $setup.channelBlockData.hasNewTab = $event),
        "data-qa": "channel-image-hasnewtab",
        class: "col-3",
        label: $setup.t("articleBlocks.newTab"),
        dense: "",
        disable: $props.locked
      }, null, 8, ["modelValue", "label", "disable"]),
      createElementVNode("div", _hoisted_4, [
        createVNode($setup["BCheckbox"], {
          modelValue: $setup.channelBlockData.isBound,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $setup.channelBlockData.isBound = $event),
          "data-qa": "channel-image-isbound",
          class: "col-3",
          label: $setup.t("articleBlocks.bound"),
          dense: "",
          disable: $props.locked
        }, null, 8, ["modelValue", "label", "disable"]),
        createVNode($setup["QIcon"], {
          name: "info",
          class: "q-ml-sm"
        }, {
          default: withCtx(() => [
            createVNode($setup["QTooltip"], {
              class: "bg-grey-10 text-white shadow-4",
              "max-width": "400px",
              anchor: "top middle",
              self: "bottom middle",
              offset: [10, 10]
            }, {
              default: withCtx(() => [
                createTextVNode(
                  toDisplayString($setup.t("articleBlocks.boundTooltip")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            })
          ]),
          _: 1
          /* STABLE */
        })
      ])
    ])
  ]);
}
const imageChannelContentBlock = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/builds/CT/content-technology-framework/modules/image/editor-ui/src/components/channel/image-channel-content-block.vue"]]);
const getDefaultImageDoc = () => ({
  title: "",
  caption: "",
  source: "",
  height: 0,
  width: 0,
  credits: "",
  focalPointX: 0,
  focalPointY: 0,
  publishDate: void 0,
  unpublishDate: void 0,
  isDeleted: false,
  isPartnerImage: false,
  createDate: resetDateTimeUnits(/* @__PURE__ */ new Date()),
  changeDate: resetDateTimeUnits(/* @__PURE__ */ new Date()),
  state: "draft",
  license: [],
  legacy: {
    source: "vibe",
    isEditableInCTF: true,
    isRenderedByCTF: true,
    hasBeenModifiedInCTF: true
  }
});
const useImageStore = defineStore("image", {
  state: () => ({
    doc: getDefaultImageDoc(),
    uploadedFile: void 0,
    blob: void 0,
    imageInstance: void 0,
    squarePreviewSrc: void 0,
    widePreviewSrc: void 0,
    ultraWidePreviewSrc: void 0,
    serverUrl: void 0
  }),
  getters: {
    url() {
      return this.blob ?? this.serverUrl ?? this.doc.source;
    }
  },
  actions: {
    clearBlobData() {
      this.blob = void 0;
      this.uploadedFile = void 0;
      this.imageInstance = void 0;
      this.squarePreviewSrc = void 0;
      this.widePreviewSrc = void 0;
      this.ultraWidePreviewSrc = void 0;
      this.serverUrl = void 0;
    },
    clearAll() {
      this.clearBlobData();
      this.doc = getDefaultImageDoc();
    }
  }
});
const useEditorImage = () => {
  const store = useImageStore();
  watch(
    () => store.uploadedFile,
    (file) => {
      if (!file)
        return;
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          store.doc.width = img.naturalWidth;
          store.doc.height = img.naturalHeight;
          store.imageInstance = img;
        };
        const result = reader.result;
        store.blob = result;
        img.src = result;
      };
      reader.readAsDataURL(file);
    }
  );
  watch(
    () => store.doc._id,
    (id) => {
      if (id) {
        const { width, height } = store.doc;
        store.serverUrl = getImageUrl(id, width, height);
      } else {
        store.clearAll();
      }
    }
  );
  return store;
};
const prefillEditorImage = (docData, file) => {
  const store = useEditorImage();
  store.doc = { ...store.doc, ...docData };
  store.uploadedFile = file;
};
const ImageContentBlock = defineAsyncComponent(() => import("./image-article-content-block-BGtH1Xd3.js"));
const EditorImage = defineAsyncComponent(() => import("./editor-image-dn2vsuTZ.js"));
const imageModule = {
  messages,
  routes,
  contentBlocks: [
    { type: "IMAGE", label: "images.contentBlockLabel", icon: "image", component: ImageContentBlock, defaultValue: getDefaultImageBlock() }
  ]
};
export {
  AspectRatio as A,
  EditorImagePlaceholder as E,
  ImageListSelector as I,
  _export_sfc as _,
  ImageService as a,
  getImage as b,
  getImageUrl as c,
  EditorImageStateOverlay as d,
  uploadImage as e,
  frameworkLimitsConfig as f,
  getDefaultImageBlock as g,
  editImage as h,
  deleteImage as i,
  ImageContentBlock as j,
  EditorImage as k,
  imageModule as l,
  avatarImage as m,
  imageChannelContentBlock as n,
  ImageModelName as o,
  prefillEditorImage as p,
  getImages as q,
  replaceImage as r,
  createImage as s,
  updateImage as t,
  useEditorImage as u
};
//# sourceMappingURL=index-C45ob1os.js.map
